export const DefaultIconsSize = {
  width: 22,
  height: 22,
};

export type IconType = unknown & {
  width?: number | string;
  height?: number | string;
};
